// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zCGY","colBig":"styles_colBig__2nzKd","colSmall":"styles_colSmall__1uogL","shopifyNameWrapper":"styles_shopifyNameWrapper__Vryhr"};